// extracted by mini-css-extract-plugin
export default {"layout":"dashboardLayout_layout__-TpFw","sider":"dashboardLayout_sider__qcQ61","headerOuter":"dashboardLayout_headerOuter__p9q-x"};